import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {SENTRY_API} from '@app/core/sentry/sentry-api';

@Injectable({
  providedIn: 'root',
})
export class DirectusErrorService {
  private readonly sentry = inject(SENTRY_API);
  private readonly router = inject(Router);

  onError(e: unknown): unknown {
    // Report before wiping state: this clears the kiosk's saved credentials and
    // bounces it back to setup, which on an unattended device looks like "the
    // kiosk logged itself out" with nothing else to go on. The event carries the
    // location identifiers being discarded so the failure can be tied to a device.
    //
    // NOTE: every caller in directus-http.service.ts currently passes its
    // `catchError` as `map`'s second argument (`thisArg`), so this method is
    // unreachable at runtime today. The reporting is here so it works the moment
    // that is fixed.
    this.sentry.captureException(e, {
      source: 'directus-kiosk-credentials-cleared',
      extra: {
        currentLocation: localStorage.getItem('currentLocation'),
        locationDirectusID: localStorage.getItem('locationDirectusID'),
      },
    });
    localStorage.removeItem('currentLocation');
    localStorage.removeItem('locationDirectusID');
    localStorage.removeItem('authToken');
    this.router.navigateByUrl('/kiosk-expo');
    return e;
  }
}
